const routerConstants = {
  routes: {
    BROADCAST_PARENT: 'broadcast_parent',
    BROADCAST: {
      GUEST: 'guest',
      INVITE_GUEST: 'invite_guest',
      HOST: 'host',
      TEST: 'test',
      INVITE_HOST: 'invite_host',
    },
    DIRECTOR: 'director',
    DIRECTOR_SETUP: 'director_setup',
    LOGIN: 'login',
    ERROR_PARENT: 'error_parent',
    ERROR: {
      UNAUTHENTICATED: 'unauthenticated',
      INVALID_INVITE: 'invalid_invite',
      INVITE_CHECK_ERROR: 'invite_check_error',
      FEATURE_FLAG_DISABLED: 'feature_flag_disabled',
    },
    LIVE_ENDED: {
      PARENT: 'live_ended_parent',
      HOST: 'live_ended_host',
      GUEST: 'live_ended_guest',
    },
  },
} as const;

export default routerConstants;
